"use client"
// needs to be on client because of react-medium-image-zoom, which uses document and window objects. If we try to use it on server, it will throw an error because document and window are not defined on server.

import "react-medium-image-zoom/dist/styles.css"

import type { ComponentProps } from "react"

import Zoom from "react-medium-image-zoom"

export type ClientZoomProps = ComponentProps<typeof Zoom>

const ClientZoom = (props: ClientZoomProps) => {
  return <Zoom {...props} />
}

export default ClientZoom
